import React, { Component } from 'react';
import { getUserRecentLogins } from '../services/recentLogins';
import NavItemExpandable from './NavItemExpandable';

export default class RecentlyVisited extends Component {
  state = { loaded: false, loading: false };

  loadRecentLogins = () => {
    if ((this.props.accessToken || this.props.sessionId) && !this.state.loading && !this.state.loaded) {
      this.setState({ loading: true });
      getUserRecentLogins(this.props.accessToken, this.props.sessionId)
        .then(data => {
          if (!this._isMounted) {
            return false;
          }
          this.setState({ data: data, loaded: true, loading: false });
        })
        .catch(() => {
          if (!this._isMounted) {
            return false;
          }
          this.setState({ loading: false });
        });
    }
  };

  componentDidMount = () => {
    this.loadRecentLogins();
    this._isMounted = true;
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  componentDidUpdate = () => {
    this.loadRecentLogins();
  };

  render() {
    const { loaded, data } = this.state;

    if (!(this.props.accessToken || this.props.sessionId)) {
      return null;
    }

    const navItem = {
      id: 'recentlyVistited',
      text: 'Recently Visited',
      iconComponent: 'IconRatingStar',
      subItems: (data || []).slice(0, 4).map(loginItem => ({
        id: loginItem.clientId,
        text: loginItem.title,
        url: loginItem.link,
      })),
    };
    return <NavItemExpandable item={navItem} isActive={true} key={navItem.id} />;
  }
}
